if (!customElements.get('momo-sticky-cart')) {
  customElements.define(
    'momo-sticky-cart',
    class MomoStickyCart extends HTMLElement {
      connectedCallback() {
        this.mobileQuery = window.matchMedia('(max-width: 767px)');
        this.button = this.querySelector('.momo-sticky-cart__button');
        this.button.addEventListener('click', () => this.handleClick());
        this.handleViewportChange = () => this.configure();
        this.mobileQuery.addEventListener?.('change', this.handleViewportChange);
        this.configure();
      }

      disconnectedCallback() {
        this.disconnectObservers();
        this.mobileQuery?.removeEventListener?.('change', this.handleViewportChange);
        document.body.classList.remove('momo-sticky-cart-visible');
      }

      configure() {
        this.disconnectObservers();
        this.seenOriginal = false;
        if (!this.mobileQuery.matches) {
          this.setVisible(false);
          return;
        }
        this.bindOriginalButton();
        const section = document.getElementById(`MainProduct-${this.dataset.sectionId}`);
        if (section) {
          this.sectionObserver = new MutationObserver(() => {
            if (!this.originalButton?.isConnected) this.bindOriginalButton();
          });
          this.sectionObserver.observe(section, { childList: true, subtree: true });
        }
      }

      bindOriginalButton() {
        this.buttonObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.originalButton = document.getElementById(this.dataset.submitId);
        if (!this.originalButton) {
          this.setVisible(false);
          return;
        }

        this.syncState();
        this.buttonObserver = new MutationObserver(() => this.syncState());
        this.buttonObserver.observe(this.originalButton, {
          attributes: true,
          childList: true,
          subtree: true,
          attributeFilter: ['disabled', 'aria-disabled', 'class'],
        });

        this.intersectionObserver = new IntersectionObserver(
          (entries) => this.updateVisibility(entries[0]),
          { threshold: [0, 0.01, 1] }
        );
        this.intersectionObserver.observe(this.originalButton);
      }

      updateVisibility(entry) {
        if (!entry || !this.mobileQuery.matches) return this.setVisible(false);
        if (entry.isIntersecting) {
          this.seenOriginal = true;
          this.setVisible(false);
          return;
        }
        const hasPassedAboveViewport = entry.boundingClientRect.bottom <= 0;
        this.setVisible(this.seenOriginal && hasPassedAboveViewport);
      }

      syncState() {
        if (!this.originalButton) return;
        const disabled =
          this.originalButton.disabled ||
          this.originalButton.getAttribute('aria-disabled') === 'true';
        const loading = this.originalButton.classList.contains('loading');
        this.button.disabled = disabled || loading;
        this.button.setAttribute('aria-busy', loading ? 'true' : 'false');
        const label = loading
          ? 'Adding…'
          : disabled
            ? this.dataset.soldOutLabel
            : this.dataset.addLabel;
        this.button.querySelector('span').textContent = label;
      }

      handleClick() {
        if (!this.originalButton || this.button.disabled) return;
        this.originalButton.click();
        this.syncState();
      }

      setVisible(visible) {
        this.hidden = !visible;
        document.body.classList.toggle('momo-sticky-cart-visible', visible);
      }

      disconnectObservers() {
        this.buttonObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.sectionObserver?.disconnect();
      }
    }
  );
}
